import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private darkMode = false;

  toggleDarkMode() {
    this.darkMode = !this.darkMode;
    const appPrivateElement = document.querySelector('app-private');
    if (appPrivateElement) {
      if (this.darkMode) {
        appPrivateElement.classList.add('dark-mode');
      } else {
        appPrivateElement.classList.remove('dark-mode');
      }
    }
  }

  isDarkMode() {
    return this.darkMode;
  }
}
